import {
  getCustomerDetail
} from '@/api'

export function initGuards (router, store) {
  router.beforeEach(async (to, from, next) => {
    //  * 去开户
    // PENDING_OPEN_ACCOUNT("01", "去开户"),
    //  * 去补全
    // PENDING_UPDATE_INFO("02", "去补全"),
    //  * 去风测
    // PENGDING_RISK("03", "去风测"),
    //  * 再次风测
    // PENGDING_AGAIN_RISK("04", "再次风测"),
    //  * 去实名
    // PENDING_ID_CHECK("05", "去实名"),
    const query = to.query

    const urlList = {
      '05': 'AccountOcr',
      '01': 'AccountBindBank',
      '03': 'AccountRiskAssessment',
      '04': 'AccountRiskAssessmentResult',
      '02': 'AccountCompleteInformation'
    }
    const detail = store.getters.customerDetail
    let currentStatus = detail.customerProcessStatus
    let risktype = detail.riskAbility
    let riskAbilityName = detail.riskAbilityName
    if (query.flow === 'new') {
      let urlName = ''

      const { code, data } = await getCustomerDetail()

      if (code === 200) {
        data.customerName = data.customerName || '新用户'
        store.dispatch('updateCustomerDetail', data)
        currentStatus = data.customerProcessStatus
        risktype = data.riskAbility
        riskAbilityName = data.riskAbilityName
      }
      urlName = urlList[currentStatus]
      if (
        query.riskSubmit === 'f' && from.name == 'AccountRiskAssessment'
      ) {
        urlName = 'AccountRiskAssessmentResult'
        query.riskType = risktype || query.riskType
        query.riskAbilityName = riskAbilityName || query.gmRiskTypeValue
      }

      if (from.name == 'AccountCompleteInformation') {
        urlName = 'AccountCompleteCrsInformation'
      }
      if (urlName !== to.name) {
        next({
          name: urlName,
          query: {
            ...query,
            flow: 'new'
          },
          replace: true
        })
      }
    }
    next()
  })
}
